import type { CollapseProps } from './const';
import { Collapse as ArcoCollapse } from '@arco-design/web-react';
import { cn } from '@utils';
import { IconAngleRight } from '@wegic/icon';
import { forwardRef } from 'react';
import './index.less';

function Collapse(props: CollapseProps, ref: React.Ref<HTMLDivElement>) {
  const { items, type = 'primary', className, ...restProps } = props;

  return (
    <ArcoCollapse
      ref={ref}
      className={cn('wg-collapse', `wg-collapse--${type}`, className)}
      bordered={false}
      {...restProps}
    >
      {items.map((itemProps) => {
        const { content, ...restItemProps } = itemProps;
        return (
          <ArcoCollapse.Item
            key={itemProps.name}
            expandIcon={<IconAngleRight style={{ fontSize: 12 }} />}
            {...restItemProps}
          >
            {content}
          </ArcoCollapse.Item>
        );
      })}
    </ArcoCollapse>
  );
}

const CollapseComponent = forwardRef<HTMLDivElement, CollapseProps>(Collapse);

CollapseComponent.displayName = 'Collapse';

export default CollapseComponent;
export type { CollapseItemConfig, CollapseProps } from './const';
